export default __webpack_public_path__ + "static/media/00.40c4f22f.jpg";